import styled from "styled-components";
import Head from "next/head";

import EventCard from 'components/EventCard';
import { request } from "utils/request";

interface Props {
  eventData: any; 
}

const Events = ({eventData}: Props) => {
  const siteTitle = `Etkinlikler | Kampp - Kampp'la Planla! | #kampplaplanla`;
  const url = "https://kampp.in/etkinlikler";

  return (
    <Container>
      <Head>
        <title>{siteTitle}</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="title" property="og:title" content={siteTitle} />
        <meta
          name="description"
          property="og:description"
          content={
            "Kamp ,Türkiye’deki kamp yerleri ve doğa evleri için kapsamlı bir doğa rehberidir. Çadır kampını, karavan parklarını, kulübeleri, ağaç evleri ve glamping'i keşfedin."
          }
        ></meta>
        <meta name="image" property="og:image" content={eventData?.[0]?.image} />
        <meta property="og:title" content={siteTitle} />
        <meta
          property="og:description"
          content={
            "Kamp ,Türkiye’deki kamp yerleri ve doğa evleri için kapsamlı bir doğa rehberidir. Çadır kampını, karavan parklarını, kulübeleri, ağaç evleri ve glamping'i keşfedin."
          }
        ></meta>
        <meta property="og:image" content={eventData?.[0]?.image} />
        <meta name="url" property="og:url" content={url} />
        <meta property="og:url" content={url} />
        <meta name="twitter:card" content="summary" />
        <meta property="twitter:title" content={siteTitle} />
        <meta
          property="twitter:description"
          content={
            "Kamp ,Türkiye’deki kamp yerleri ve doğa evleri için kapsamlı bir doğa rehberidir. Çadır kampını, karavan parklarını, kulübeleri, ağaç evleri ve glamping'i keşfedin."
          }
        ></meta>
        <meta property="twitter:url" content={url} />
      </Head>

      <EventContainer>
        {eventData?.filter((evnt: any) => new Date(evnt?.startDate) > new Date())?.map((event: any) => (
          <EventCard key={event.id} event={event} />
        ))}
      </EventContainer>
    </Container>
  )
}

export async function getServerSideProps(context: any) {
  const { data }: any = await request("event/getAllEventsWithPagination?page=1&pageSize=100", "GET");

  return {
    props: {
      eventData: data?.data?.eventData || [],
    },
  };
}

// export async function getStaticProps() {
//   const { data }: any = await request("event/getAllEventsWithPagination?page=1&pageSize=100", "GET");
//   return {
//     props: {
//       eventData: data?.data?.eventData || [],
//     },
//   };
// }

const Container = styled.div`
  padding: 65px 25%;
  @media (max-width: ${(props) => props.theme.size.laptopL}) {
    padding: 65px 15%;
  }
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    padding: 65px 30px;
  }
`;

const EventContainer = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0px, 1fr));
  grid-gap: 30px;
  @media (max-width: ${(props) => props.theme.size.laptopXl}) {
    grid-template-columns: repeat(3, minmax(0px, 1fr));
  }
  @media (max-width: ${(props) => props.theme.size.laptopL}) {
    grid-template-columns: repeat(3, minmax(0px, 1fr));
  }
  @media (max-width: ${(props) => props.theme.size.laptop}) {
    grid-template-columns: repeat(2, minmax(0px, 1fr));
  }
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    grid-template-columns: repeat(1, minmax(0px, 1fr));
  }
`;

export default Events;